import React from 'react';
import { ErsteSeite, VorherigeSeite, NächsteSeite, LetzteSeite } from '../icons';
import './Pagination.css';

/**
 * Wiederverwendbare Pagination-Komponente.
 *
 * Props:
 *  - page:        aktuelle Seite (0-basiert)
 *  - totalPages:  Gesamtanzahl Seiten
 *  - totalItems:  Gesamtanzahl Einträge
 *  - pageSize:    Einträge pro Seite
 *  - onPageChange: (newPage: number) => void
 *  - label:       Bezeichnung der Einträge (z.B. "Geräte", "Alarme")
 */
function Pagination({ page, totalPages, totalItems, pageSize, onPageChange, label = 'Einträge' }) {
  if (totalItems <= 0 || totalPages <= 0) return null;

  const startIndex = page * pageSize + 1;
  const endIndex = Math.min((page + 1) * pageSize, totalItems);

  return (
    <div className="pagination pagination-right">
      <div className="pagination-controls">
        <span className="pagination-info">
          {label} {startIndex}–{endIndex}{totalItems > pageSize ? ` von ${totalItems}` : ''}
        </span>
        <button
          disabled={page === 0}
          onClick={() => onPageChange(0)}
          aria-label="Erste Seite"
          title="Erste Seite"
        >
          <ErsteSeite />
        </button>
        <button
          disabled={page === 0}
          onClick={() => onPageChange(page - 1)}
          aria-label="Vorherige Seite"
          title="Vorherige Seite"
        >
          <VorherigeSeite />
        </button>
        <span className="pagination-page">
          {page + 1} / {totalPages}
        </span>
        <button
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(page + 1)}
          aria-label="Nächste Seite"
          title="Nächste Seite"
        >
          <NächsteSeite />
        </button>
        <button
          disabled={page >= totalPages - 1}
          onClick={() => onPageChange(totalPages - 1)}
          aria-label="Letzte Seite"
          title="Letzte Seite"
        >
          <LetzteSeite />
        </button>
      </div>
    </div>
  );
}

export default Pagination;
